module.exports = __webpack_public_path__ + "static/video-a1883d48a042aeecd726f62c1e854a63.mp4";